import type { IBound } from '@blocksuite/global/utils';

import type { MindmapHighlightElementModel } from '../../element-model/mindmap-highlight.js';
import type { RoughCanvas } from '../../rough/canvas.js';
import type { Renderer } from '../renderer.js';

export function mindmapHighlight(
    model: MindmapHighlightElementModel,
    ctx: CanvasRenderingContext2D,
    matrix: DOMMatrix,
    _renderer: Renderer,
    _rc: RoughCanvas,
    _viewportBound: IBound
) {
    const [, , w, h] = model.deserializedXYWH;
    const cx = w / 2;
    const cy = h / 2;

    ctx.setTransform(
        matrix.translateSelf(cx, cy).rotateSelf(0).translateSelf(-cx, -cy)
    );

    const now = performance.now();
    const progress = Math.min(
        Math.max((now - model.startMs) / model.durationMs, 0),
        1
    );

    const radius = 18;
    const baseAlpha = 0.06 * (progress < 0.2 ? progress / 0.2 : progress > 0.8 ? (1 - progress) / 0.2 : 1);
    const main = model.colorMain || 'rgba(166, 86, 244, 0.1)';
    const gradient = ctx.createLinearGradient(0, 0, w, 0);
    gradient.addColorStop(0, withAlpha(main, baseAlpha));
    gradient.addColorStop(1, withAlpha(main, baseAlpha));

    ctx.fillStyle = gradient;
    ctx.beginPath();
    ctx.roundRect(0, 0, w, h, radius);
    ctx.fill();
}

function withAlpha(rgbOrHex: string, alpha: number) {
    if (rgbOrHex.startsWith('rgba')) return rgbOrHex;
    if (rgbOrHex.startsWith('rgb(')) {
        const body = rgbOrHex.slice(4, -1);
        return `rgba(${body}, ${alpha})`;
    }
    // simple hex fallback
    return `rgba(140, 92, 245, ${alpha})`;
}


